import { IUser } from '@Data/users/Interfaces';
import { ITeam } from './Interfaces';

export interface ITeamState {
    teams: Array<ITeam> | null;
    selectedTeam: ITeam | null;
    teamMembers: Array<IUser>;
    teamMembersInDepartment: Array<IUser>;
}

export const initialTeamState: ITeamState = {
    teams: null,
    selectedTeam: null,
    teamMembers: [],
    teamMembersInDepartment: [],
};
